<div>
    <p>Are you sure want to cancel the trip</p>
</div>
<mat-divider></mat-divider>
<div class="row">
    <div class="col-md-6 p-0 col-sm-6 col-6">
        <a class="trip" (click)="tripCancel(modeldata)">Yes</a>
        <mat-divider [vertical]="true" class="divider"></mat-divider>
    </div>
    <div class="col-md-6 p-0 col-sm-6 col-6">
        <a class="trip" (click)="GoToTrip()">No</a>
    </div>
</div>
